import { useState } from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import SuperAdminSidebar from "./SuperAdminSidebar";
import { FaCopy } from "react-icons/fa";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

const UserLoginDetails = () => {
  const [copiedField, setCopiedField] = useState("");

  const location = useLocation();

  const loginDetails = {
    Email: location.state?.userData?.Email || "null",
    Password: location.state?.userData?.Password || "null",
  };

  const handleCopy = (text, field) => {
    navigator.clipboard.writeText(text);
    setCopiedField(field);
    setTimeout(() => setCopiedField(""), 1500);
  };

  const navigate = useNavigate();

  return (
    <>
      <SuperAdminSidebar />
      <Container className="card mt-4">
        <h4 className="text-center text-primary" style={{ fontWeight: "bold" }}>
          User Login Details
        </h4>

        <h5 className="text-center text-secondary mt-3">
          Please copy the user login details below and share them with the user
          to allow access.
        </h5>
        <hr />

        <Row className="mb-3 justify-content-center">
          <Col md={6}>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label
                  className="text-start d-block"
                  style={{ fontWeight: "bold" }}>
                  User Email
                </Form.Label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Control
                    type="text"
                    value={loginDetails.Email}
                    readOnly
                  />
                  <button
                    type="button"
                    onClick={() => handleCopy(loginDetails.Email, "Email")}
                    style={{
                      marginLeft: 8,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.2rem",
                    }}
                    title="Copy Username">
                    <FaCopy style={{ color: "#e5c15f" }} />
                  </button>
                  {copiedField === "Email" && (
                    <span style={{ marginLeft: 8, color: "green" }}>
                      Copied!
                    </span>
                  )}
                </div>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label
                  className="text-start d-block"
                  style={{ fontWeight: "bold" }}>
                  User Password
                </Form.Label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Control
                    type="text"
                    value={loginDetails.Password}
                    readOnly
                  />
                  <button
                    type="button"
                    onClick={() =>
                      handleCopy(loginDetails.Password, "Password")
                    }
                    style={{
                      marginLeft: 8,
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      fontSize: "1.2rem",
                    }}
                    title="Copy Password">
                    <FaCopy style={{ color: "#e5c15f" }} />
                  </button>
                  {copiedField === "Password" && (
                    <span style={{ marginLeft: 8, color: "green" }}>
                      Copied!
                    </span>
                  )}
                </div>
              </Form.Group>

              {/* buttons */}
              <div className="d-flex justify-content-end gap-3 mt-4">
                <button
                  type="button"
                  className="btn btn-outline-primary fw-semibold"
                  onClick={() => {
                    const csvContent = `Email,Password\n${loginDetails.Email},${loginDetails.Password}`;
                    const blob = new Blob([csvContent], {
                      type: "text/csv;charset=utf-8;",
                    });
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "UserLoginDetails.csv");
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                  }}>
                  Download .csv file
                </button>

                <button
                  type="button"
                  className="btn"
                  style={{
                    backgroundColor: "#FFA500", // orange
                    color: "black",
                    fontWeight: "bold",
                  }}
                  onClick={() => navigate("/superadmindashboard")}>
                  Return to users list
                </button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default UserLoginDetails;
